import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

import pantryIcon from '@/components/pantry/PantryBtn/images/pantry_v5.png';

type Props = {
  className?: string;
};

const ethnic = 'Asian';
const webDesc = 'Weee!';

export default function PantryIcon({ className }: Props) {
  return (
    <img
      data-testid="wid-pantry-icon"
      className={twMerge('h-[18px] w-auto', className)}
      src={pantryIcon}
      alt={`${webDesc} - ${ethnic} groceries delivered`}
    />
  );
}
